import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const AddModel = ({ title, isAddModel, setIsAddModel, message }) => {
    const toggle = () => setIsAddModel(!isAddModel);

    return (
        <div>
            <Modal isOpen={isAddModel} toggle={toggle} size={"lg"}>
                <ModalHeader toggle={toggle}>{title}</ModalHeader>
                <ModalBody>
                    {message}
                </ModalBody>
            </Modal>
        </div>
    );
}

export default AddModel;